import { EquipmentReportType } from '../enums'

export class EquipmentReport {
    id!: string
    reportType!: EquipmentReportType
    equipment?: string
    dateTime?: Date
    operatorHrRef?: number
    job?: string
    createdOn?: Date
}
